module.exports = __webpack_public_path__ + "static/media/plus.1655dd0f.svg";